"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = Map;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _useTabs = _interopRequireDefault(require("../../providers/useTabs/useTabs"));
var _map = _interopRequireDefault(require("./map.css"));
var _googleMap = _interopRequireDefault(require("../../utils/location/googleMaps/google-map/google-map"));
var _mapStyles = require("./map-styles");
function Map(props) {
  var dealers = props.dealers,
    query = props.query,
    location = props.location,
    market = props.market,
    language = props.language,
    selectedDealer = props.selectedDealer,
    markerSelected = props.markerSelected,
    defaultLatitude = props.defaultLatitude,
    defaultLongitude = props.defaultLongitude;
  var unformattedSelectedDealer;
  if ((dealers == null ? void 0 : dealers.length) > 0 && selectedDealer) {
    unformattedSelectedDealer = dealers.find(function (item) {
      return item.id === selectedDealer.id;
    });
  } else {
    unformattedSelectedDealer = null;
  }
  var defaultLocation = {
    fullAddress: query,
    latitude: defaultLatitude == null ? void 0 : defaultLatitude.lat,
    longitude: defaultLongitude == null ? void 0 : defaultLongitude.lng
  };
  var markerList = [];
  if (unformattedSelectedDealer) {
    markerList.push({
      position: {
        lat: unformattedSelectedDealer.dealerLocation.latitude,
        lng: unformattedSelectedDealer.dealerLocation.longitude
      }
    });
  } else {
    dealers.forEach(function (dealer) {
      var position = {
        dealer: dealer,
        position: {
          lat: dealer.dealerLocation.latitude,
          lng: dealer.dealerLocation.longitude
        }
      };
      markerList.push(position);
    });
  }
  var addressList = [];
  dealers.forEach(function (addressData) {
    var fullAddress = addressData.dealerLocation.city;
    addressList.push(fullAddress);
  });
  var tabs = (0, _useTabs["default"])();
  var mapConfig = {
    center: !defaultLocation.longitude ? {
      lat: 39,
      lng: -100
    } : {
      lat: defaultLocation.latitude,
      lng: defaultLocation.longitude
    },
    zoom: 10,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: true,
    styles: _mapStyles.MapStyles
  };
  if (unformattedSelectedDealer) {
    mapConfig['center'] = {
      lat: unformattedSelectedDealer.dealerLocation.latitude,
      lng: unformattedSelectedDealer.dealerLocation.longitude
    };
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _map["default"].wrapper + " " + (!tabs.showMap ? _map["default"].hide : '')
  }, /*#__PURE__*/_react["default"].createElement(_googleMap["default"], {
    className: _map["default"].map,
    markers: markerList,
    config: mapConfig,
    currentLocation: defaultLocation,
    region: market,
    language: language,
    refinedDealerList: dealers,
    dealerList: dealers,
    selectedDealer: unformattedSelectedDealer,
    markerSelected: markerSelected
  }));
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    googleMapsApiKey: state.Config.googleApiKey
  };
};